<template>
	<div>
		<app-inbox-loading v-if="isDataLoading" />
		<div v-else>
			<b-row>
				<b-col v-if="false">
					<b-button class="btn-close-page float-right mb-2" @click="$emit('closePage')" v-b-tooltip.hover title="Close"><b-icon-x /></b-button>
					<b-button class="btn-close-page float-right mb-2 mr-2" @click="$emit('approvalFlow')" v-b-tooltip.hover title="Approval History"><b-icon icon="clock-history" /></b-button>
				</b-col>
			</b-row>
			<b-card header="Work Order Process" class="mb-3">
				<b-row>
					<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Work Order Process Number" :model="model.workOrderProcessNumber" />
						<app-input-datepicker  id="fieldset-production-date" label-cols-lg="12" label="Production Date" size="sm" :model.sync="model.productionDate" :isRequired="true" :state="validateState('productionDate')" :errorMessage="getErrorMessage(errorMessage.productionDate, 'productionDate')"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" :isEditable="false" :isUpdatable="true" />
						<app-input-combobox-autocomplete :options="lines" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Line Code" id="fieldset-line-code" size="sm" :model.sync="model.lineCodeId" :isRequired="true" :state="validateState('lineCodeId')" :errorMessage="getErrorMessage(errorMessage.lineCodeId, 'lineCodeId')"   :selected="model.lineCode != null ? model.lineCode.code : ''" @input="getLines" @change="updateData" :isEditable="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedLineCode" :isUpdatable="true"/>
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="processTypes" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Process Type" id="fieldset-process-type" size="sm" :model.sync="model.processTypeId" :isRequired="true" :state="validateState('processTypeId')" :errorMessage="getErrorMessage(errorMessage.processTypeId, 'processTypeId')"   :selected="model.processType != null ? model.processType.code : ''" @input="getProcessTypes" @change="onProcessTypeChange" :isEditable="false" :isUpdatable="true"/>
						<app-label label-cols-lg="12" size="sm" label="Process Type" :model="model.processType != null ? model.processType.name :''" />
						<app-input-combobox-autocomplete v-if="inboxType == 'FINISHEDSUBMISSION'" :options="documentStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Document Status" id="fieldset-document-status" size="sm" :model.sync="model.documentStatusId"   :selected="model.documentStatus != null ? model.documentStatus.name : ''" @input="getDocumentStatuss" @change="updateData" :isEditable="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedDocumentStatus" :isUpdatable="true"/>
					</b-col>
				</b-row>
			</b-card>

		<app-table-input-popup title="Work Order Process Detail" :bordered="true" :items="workOrderProcessDetails" :fields="fieldsWorkOrderProcessDetail" :busy="isDataLoading" :sort-by.sync="sortByWorkOrderProcessDetail" :sort-desc.sync="sortDescWorkOrderProcessDetail" small responsive
			@editButtonMethod="editRowDataWorkOrderProcessDetail"
			@deleteButtonMethod="deleteRowDataWorkOrderProcessDetail"
			@showPopupAddMethod="resetDataWorkOrderProcessDetail()"
			@showPopupUploadMethod="showPopupUploadWorkOrderProcessDetail()"
			@downloadMethod="downloadWorkOrderProcessDetail()"
			@addFromClipboardMethod="addFromClipboardWorkOrderProcessDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardWorkOrderProcessDetail()"
			:showActionButton="false"
			:showEditButton="false"
			:showDeleteButton="false"
			:showAddButton="false"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadWorkOrderProcessDetail"
			>
			<template #top-row v-if="isShowWorkOrderProcessDetailFilter">
				<b-th></b-th>
				<b-th></b-th>
							<b-th stacked-heading="Part Number">
								<v-select append-to-body label="partNumber" :options="parts"  :value="filterWorkOrderProcessDetail.partId" :reduce="item => item.id" v-model="filterWorkOrderProcessDetail.partId" @search="getParts" :filterable="true"></v-select>
							</b-th>
							<b-th stacked-heading="Line Machine">
								<v-select append-to-body label="code" :options="machines"  :value="filterWorkOrderProcessDetail.machineId" :reduce="item => item.id" v-model="filterWorkOrderProcessDetail.machineId" @search="getMachines" :filterable="true"></v-select>
							</b-th>
							<b-th stacked-heading="Qty (Plan)">
								<b-form-input id="input-qty-plan-table" v-model="filterWorkOrderProcessDetail.qtyPlan" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Hour (Plan)">
								<b-form-input id="input-hour-plan-table" v-model="filterWorkOrderProcessDetail.hourPlan" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Remark">
								<b-form-input id="input-remark-table" v-model="filterWorkOrderProcessDetail.remark" size="sm"></b-form-input>
							</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( workOrderProcessDetailPageSize * (currentWorkOrderProcessDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
						<template v-slot:cell(workOrderProcess)="row">
							{{ row.item != null ? row.item.workOrderProcess != null ? row.item.workOrderProcess.workOrderProcessNumber : "" : "" }}
						</template>
						<template v-slot:cell(printAction)="row" v-if="inboxType == 'FINISHEDSUBMISSION'">
							<b-dropdown text="Print Action" class="m-md-2 btn-action-more position-static">
								<b-dropdown-item @click="printPdfCustom(row.item)"><b-icon-printer></b-icon-printer> Print WO Process</b-dropdown-item>
								<b-dropdown-item @click="printPcc(row.item)"><b-icon-printer></b-icon-printer> Print PCC</b-dropdown-item>
								<b-dropdown-item @click="printPccAdditional(row.item)" :class="{ 'disabled-item': !row.item.isPrintLabel }" :disabled="!row.item.isPrintLabel"><b-icon-printer></b-icon-printer> Print PCC Additional</b-dropdown-item>
								<b-dropdown-item @click="printPccPending(row.item)"><b-icon-printer></b-icon-printer> Print Pending Card</b-dropdown-item>
								<b-dropdown-item @click="printPccNg(row.item)"><b-icon-printer></b-icon-printer> Print NG Card</b-dropdown-item>
							</b-dropdown>
						</template>
						<template v-slot:cell(part)="row">
							{{ row.item.partPartNumber != null ? row.item.partPartNumber : row.item != null ? row.item.part != null ? row.item.part.partNumber : "" : "" }}
						</template>
						<template v-slot:cell(partName)="row">
									<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.partPartName != null) ? row.item.partPartName : (row.item.part != null) ? row.item.part.partName : null"  />
						</template>
						<template v-slot:cell(partClassification)="row">
									<app-label label-cols-lg="12" size="sm" label="Part Classification" :model="(row.item.part != null) ? (row.item.part.partClassification != null) ? row.item.part.partClassification.code : null : null"  />
						</template>
						<template v-slot:cell(standarPackagingQty)="row">
									<app-label label-cols-lg="12" size="sm" label="Standard Packaging Qty" :model="(row.item.part != null) ? row.item.part.standarPackagingQty : null"  />
						</template>
						<template v-slot:cell(nextProcess)="row">
									<app-label label-cols-lg="12" size="sm" label="NextProcess" :model="(row.item.billOfProcess != null) ? (row.item.billOfProcess.nextProcess != null) ? row.item.billOfProcess.nextProcess.name : null : null"  />
						</template>
						<template v-slot:cell(machine)="row">
							{{ row.item != null ? row.item.machine != null ? row.item.machine.code : "" : "" }}
						</template>
						<template v-slot:cell(sph)="row">
									<app-label label-cols-lg="12" size="sm" label="Stroke Per Hour" :model="(row.item.machine != null) ? row.item.machine.sph : null"  />
						</template>
						<template v-slot:cell(customer)="row">
									<app-label label-cols-lg="12" size="sm" label="Customer" :model="(row.item.part != null) ? (row.item.part.customer != null) ? row.item.part.customer.code : null : null"  />
						</template>
						<template v-if="inboxType == 'FINISHEDSUBMISSION'" v-slot:cell(documentStatus)="row">
							<div class="two-item">
								<span>{{ row.item.documentStatus != null ? row.item.documentStatus.name : "" }} </span>
								<span :class="getRectangleClass(row.item.documentStatusId)">&nbsp;</span>
							</div>
						</template>

			<template v-slot:form-add-detail>
				<WorkOrderProcessDetailInput 
					:openPopup="isShowPopupWorkOrderProcessDetail"
					:modelId="workOrderProcessDetailId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataWorkOrderProcessDetail"/>
			</template>
			<template v-slot:upload-detail>
				<WorkOrderProcessDetailUpload
					:openPopup="isShowPopupUploadWorkOrderProcessDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataWorkOrderProcessDetail"
					:parentId="modelId"
					/>
			</template>
						<template #row-details="row">
							<b-card>
							<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.part != null) ? row.item.part.partName : null"  />
							<app-label label-cols-lg="12" size="sm" label="Part Classification" :model="(row.item.part != null) ? (row.item.part.partClassification != null) ? row.item.part.partClassification.code : null : null"  />
							<app-label label-cols-lg="12" size="sm" label="Standard Packaging Qty" :model="(row.item.part != null) ? row.item.part.standarPackagingQty : null"  />
					<app-input-combobox-autocomplete :options="billOfProcesss" optionsLabel="partNumber" optionsKey="id" :id="'input-work-order-process-detail-bill-of-process-' + row.index" label-cols-lg="12" label="Bill Of Process" size="sm" :model.sync="row.item.billOfProcessId"  @change="saveInputWorkOrderProcessDetail(row.item)" :selected="row.item.billOfProcess != null ? row.item.billOfProcess.partNumber : ''"  @input="getBillOfProcesss" :loading="isBillOfProcessComboLoading"  :isUpdatable="false" :isEditable="false"  />
							<app-label label-cols-lg="12" size="sm" label="NextProcess" :model="(row.item.billOfProcess != null) ? (row.item.billOfProcess.nextProcess != null) ? row.item.billOfProcess.nextProcess.name : null : null"  />
					<app-input-combobox-autocomplete :options="machines" optionsLabel="code" optionsKey="id" :id="'input-work-order-process-detail-machine-' + row.index" label-cols-lg="12" label="Line Machine" size="sm" :model.sync="row.item.machineId" :state="validateState('machineId')" :errorMessage="getErrorMessage(errorMessage.machineId, 'machineId')"  @change="saveInputWorkOrderProcessDetail(row.item)" :selected="row.item.machine != null ? row.item.machine.code : ''"  @input="getMachines" :loading="isMachineComboLoading"  :isUpdatable="false" :isEditable="false"  />
							<app-label label-cols-lg="12" size="sm" label="Stroke Per Hour" :model="(row.item.machine != null) ? row.item.machine.sph : null"  />
					<app-input-textbox :id="'input-work-order-process-detail-qty-plan-' + row.index" label-cols-lg="12" label="Qty (Plan)" size="sm" :model.sync="row.item.qtyPlan" :state="validateState('qtyPlan')" :errorMessage="getErrorMessage(errorMessage.qtyPlan, 'qtyPlan')"   @change="saveInputWorkOrderProcessDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-work-order-process-detail-hour-plan-' + row.index" label-cols-lg="12" label="Hour (Plan)" size="sm" :model.sync="row.item.hourPlan"   @change="saveInputWorkOrderProcessDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
							<app-label label-cols-lg="12" size="sm" label="Customer" :model="(row.item.part != null) ? (row.item.part.customer != null) ? row.item.part.customer.code : null : null"  />
					<app-input-textarea :id="'input-work-order-process-detail-remark-' + row.index" label-cols-lg="12" label="Remark" size="sm" :model.sync="row.item.remark"  @change="saveInputWorkOrderProcessDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
							</b-card>
						</template>

		</app-table-input-popup>

			<PopupPDF :openPopup="isShowPopUpPdf" :pdfUrl="pdfUrl" @resetModalMethod="resetModal" label="Print WO Process" />
			<PopupPDF :openPopup="isShowPopUpPdfList" :pdfUrl="pdfUrlList" @resetModalMethod="resetModal" label="Print WO List" />


			<b-overlay :show="isBusy" no-wrap></b-overlay>
			<Portal to="app-inbox-button">
				<app-approval-button
					@approveMethod="editRequestAction" 
					:showApproveButton="true" 
					approveButtonTitle="Edit Request"
					:showRejectButton="false"
					:showRevisionButton="false"
					v-if="false"
					/>
				<div v-if="inboxType == 'FINISHEDSUBMISSION'">
					<b-button @click="printWoList(model.id)" class="ml-2 mt-2 mt-sm-0 btn-outline-success" size="sm"><b-icon-printer></b-icon-printer> Print WO List</b-button>
					<b-button @click="printPdfCustom('all')" class="ml-2 mt-2 mt-sm-0 btn-outline-success" size="sm"><b-icon-printer></b-icon-printer> Print WO Process</b-button>
				</div>
			</Portal>
		</div>
	</div>
</template>
<style scoped>
	.two-item {
		display: flex;
		padding: 10px;
		justify-content: space-between;
		align-items: center;
	}
	.rectangle {
		width: 30px;
		height: 30px;
	}
	.rectangle-danger {
		background-color: #DC3545;
	}
	.rectangle-warning {
		background-color: #FFC107;
	}
	.rectangle-success {
		background-color: #28A745;
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import WorkOrderProcess from '@/models/WorkOrderProcess/WorkOrderProcess';
import WorkOrderProcessList from '@/models/WorkOrderProcess/WorkOrderProcessList';
import WorkOrderProcessFilter from '@/filters/WorkOrderProcess/WorkOrderProcessFilter';
import moment from 'moment';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppLabel from '@/components/AppLabel';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Line from '@/models/Line/Line';
import LineFilter from '@/filters/Line/LineFilter';
import ProcessType from '@/models/ProcessType/ProcessType';
import ProcessTypeFilter from '@/filters/ProcessType/ProcessTypeFilter';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import WorkOrderProcessDetail from '@/models/WorkOrderProcess/WorkOrderProcessDetail';
import WorkOrderProcessDetailFilter from '@/filters/WorkOrderProcess/WorkOrderProcessDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import BillOfProcess from '@/models/BillOfProcess/BillOfProcess';
import BillOfProcessFilter from '@/filters/BillOfProcess/BillOfProcessFilter';
import Machine from '@/models/Machine/Machine';
import MachineFilter from '@/filters/Machine/MachineFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import WorkOrderProcessDetailInput from '@/views/WorkOrderProcess/WorkOrderProcessDetailInput';
import WorkOrderProcessDetailUpload from '@/views/WorkOrderProcess/WorkOrderProcessDetailUpload';

import PopupRouterView from '@/components/PopupRouterView';
import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';
import PopupRouterViewApprovalDetail from '@/components/PopupRouterViewApprovalDetail';
import AppApprovalButton from '@/components/AppApprovalButton';
import PopupPDF from '@/components/PopupPDF';

export default {
	props: 
		{
			selectedModelId: {
				default: "",
				type: String
			},
			selectedModel: {
				default: null,
				type: Object
			},
			successAction: {},
			inboxType: {
				default: "",
				type: String
			}
		}
	,
	components : {
		AppLabel,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		WorkOrderProcessDetailInput,
		WorkOrderProcessDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewApprovalDetail, 
		PopupRouterView,
		AppApprovalButton,
		AppInputTextarea,
		PopupPDF,
		PopupRouterViewApprovalDetail, 
		PopupRouterViewDetail,
		PopupRouterView,
		AppApprovalButton,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			productionDate: {required},
			lineCodeId: {required},
			processTypeId: {required},
		}
	},

	data() {
		return {
			errorMessage : {
				productionDate: { required : "Production Date is Required."},
				lineCodeId: { required : "Line Code is Required."},
				processTypeId: { required : "Process Type is Required."},
			},

			datas: Array(),
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			isShowDataDetailFilter: false,
			isDownloadDataDetail: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			backroute: '',
			approvalConfiguration: {},
			fieldsWorkOrderProcessDetail: [
				//{"frontActions": { "class" : "th-actions", "label" : ""}},
			],
			modelWorkOrderProcessDetail : {},
			isShowPopupWorkOrderProcessDetail : false,
			isShowPopupUploadWorkOrderProcessDetail : false,
			filterWorkOrderProcess : null,
			currentWorkOrderProcessPage : 1,
			workOrderProcessPageSize: 10,
			sortByWorkOrderProcess: '',
			sortDescWorkOrderProcess: '',
			filterWorkOrderProcessDetail : null,
			currentWorkOrderProcessDetailPage : 1,
			workOrderProcessDetailPageSize: 10,
			sortByWorkOrderProcessDetail: '',
			sortDescWorkOrderProcessDetail: '',
			sortingByWorkOrderProcessDetail: [],
			workOrderProcessDetails : [],
			workOrderProcessDetailId : '',
			totalWorkOrderProcessDetailRow : 0,
			isShowWorkOrderProcessDetailFilter: false,
			isDownloadWorkOrderProcessDetail: false,
			parts: [],
			billOfProcesss: [],
			machines: [],
			lines: [],
			lineCodes: [],
			isLineCodeComboLoading: false,
			processTypes: [],
			processTypes: [],
			isProcessTypeComboLoading: false,
			backroute: '',
			isLineComboLoading: false,
			isProcessTypeComboLoading: false,
			isDocumentStatusComboLoading: false,
			isWorkOrderProcessComboLoading: false,
			isPartComboLoading: false,
			isBillOfProcessComboLoading: false,
			isMachineComboLoading: false,
			documentStatuss: [],
			isShowPopUpPdf: false,
			pdfUrl: '',
			isShowPopUpPdfList: false,
			pdfUrlList: '',

		}
	},
	methods : {
		printPccPending: async function(item) {
			try {

				if(item.printPendingBy) {
					let message = `<b>PCC Pending</b> sudah pernah di print pada tanggal <b>${moment(item.printPendingDate).format("DD-MMM-YYYY")}</b> oleh <b>${item.printPendingBy}</b>, apakah yakin untuk print ulang?`;
					if(!await this.showPopupWithMessage(message)) return;
				}

				let data = parseInt(item.id);
				if(!isNaN(data)) {
					await WorkOrderProcessDetail.printPCCPending(this, data).then(async result => {
						if(result.result == "OK") {
							this.$bvToast.toast("Succeed Printing to ZPL Printer", {
								title: 'Print PCC Pending',
								variant: 'success',
								solid: true,
								autoHideDelay: 3000 // Optional: Mengatur durasi pesan
							});

							await this.getWorkOrderProcess(this.model.id);
						}
					});
				}
			} catch (error) {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			}
		},
		printPccNg: async function(item) {
			try {

				if(item.printNgBy) {
					let message = `<b>PCC NG</b> sudah pernah di print pada tanggal <b>${moment(item.printNgDate).format("DD-MMM-YYYY")}</b> oleh <b>${item.printNgBy}</b>, apakah yakin untuk print ulang?`;
					if(!await this.showPopupWithMessage(message)) return;
				}

				let data = parseInt(item.id);
				if(!isNaN(data)) {
					await WorkOrderProcessDetail.printPCCNg(this, data).then(async result => {
						if(result.result == "OK") {
							this.$bvToast.toast("Succeed Printing to ZPL Printer", {
								title: 'Print PCC NG',
								variant: 'success',
								solid: true,
								autoHideDelay: 3000 // Optional: Mengatur durasi pesan
							});

							await this.getWorkOrderProcess(this.model.id);
						}
					});
				}
			} catch (error) {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			}
			
		},
		getRectangleClass(documentStatus) {
			console.log("documentStatus", documentStatus);
			let cls = "rectangle";
			if(documentStatus == "CLOSED") {
				cls += " rectangle-success";
			} else if(documentStatus == "IN_PROGRESS" || documentStatus == "IN_PROGRESS_PRODUCTION" || documentStatus == "IN_PROGRESS_RFP") {
				cls += " rectangle-warning";
			} else {
				cls += " rectangle-danger";
			}

			console.log("class", cls);
			return cls;
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.Name = input;
			}
			this.isDocumentStatusComboLoading = true;
			DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
				this.isDocumentStatusComboLoading = false;
			})
			.catch(error => {});
		},
		printWoList: async function(item) {
			try {
				this.isBusy = true;
				let data = parseInt(item);
				if(!isNaN(data)) {
					let result = await WorkOrderProcess.printWoList(this, data, this.model.workOrderProcessNumber);
					if(result) {
						this.isShowPopUpPdfList = true;
						this.pdfUrlList = result.download;
					}
					this.isBusy = false;
				}
			} catch(error) {
				this.isShowPopUpPdfList = false;
				this.pdfUrlList = '';
				this.isBusy = false;
			}
		},
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		printPcc: async function(item) {

			if(item.isPrintLabel) {
				let message = `<b>PCC</b> sudah pernah di print pada tanggal <b>${moment(item.printDate).format("DD-MMM-YYYY")}</b> oleh <b>${item.printBy}</b>, apakah yakin untuk print ulang?`;
				if(!await this.showPopupWithMessage(message)) return;
			}

			let data = parseInt(item.id);
			console.log("data", data);
			if(!isNaN(data)) {
				const response = await WorkOrderProcessDetail.printPCC(this, data);
					console.log("result", response);
					if(response) {
						
						this.$bvToast.toast("Succeed Printing to ZPL Printer", {
							title: 'Print PCC',
							variant: 'success',
							solid: true,
							autoHideDelay: 3000 // Optional: Mengatur durasi pesan
						});

						await this.getWorkOrderProcess(this.model.id);
					}
			}
		},
		printPccAdditional: async function(item) {
			let data = parseInt(item.id);
			if(!isNaN(data)) {
				await WorkOrderProcessDetail.printPCCAdditional(this, data).then(result => {
					if(result.result == "OK") {
						this.$bvToast.toast("Succeed Printing to ZPL Printer", {
							title: 'Print PCC Additional',
							variant: 'success',
							solid: true,
							autoHideDelay: 3000 // Optional: Mengatur durasi pesan
						});
					}
				});
			}
		},
		printPdfCustom: async function(data) {
			try {
				let ids = [];
				if(data == "all") {
					this.workOrderProcessDetails.forEach(item => {
						let id = parseInt(item.id)
						if(!isNaN(id)) {
							ids.push(id);
						}
					});

					console.log("all", ids);
				} else {
					let id = parseInt(data.id);
					if(!isNaN(id)) {
						ids.push(id);
					}

					console.log("single", ids);
				}

				let result = await WorkOrderProcessDetail.printPdfCustom(this, ids);
				if(result) {
					console.log("result pdf", result)
					this.isShowPopUpPdf = true;
					this.pdfUrl = result.download;
				}
			} catch(error) {
				this.isShowPopUpPdf = false;
				this.pdfUrl = '';
			}
		},
		getWorkOrderProcess : async function(id) {
			this.isDataLoading = true;
			this.getWorkOrderProcessDetails();

			
			WorkOrderProcess.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				//WorkOrderProcess.getApprovalConfigurationInput(this, result.approvalInstanceId).then(result => { this.approvalConfiguration = result; this.isDataLoading = false; }).catch(() => { this.isDataLoading = false; });
				this.isDataLoading = false;
			}).catch(error => { this.isDataLoading = false; });
		},
		downloadData() {
			this.isDownloadWorkOrderProcess = true;
			this.filterWorkOrderProcess.id = this.modelId;
			WorkOrderProcess.downloadDataDetail(this, this.filterWorkOrderProcess).then(result => {
				this.isDownloadWorkOrderProcess = false;
			}).catch(error => { this.isDownloadWorkOrderProcess = false; })
		},
		getWorkOrderProcessDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterWorkOrderProcessDetail);
			if (this.modelId == null) return;
			filter.workOrderProcessId = this.modelId;
			//filter.draftMode = "0";
			if (this.sortByWorkOrderProcessDetail != null) {
				this.sortingByWorkOrderProcessDetail[this.sortByWorkOrderProcessDetail] = this.sortDescWorkOrderProcessDetail;
			}
			let currentPage = (this.currentWorkOrderProcessDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalWorkOrderProcessDetailRow + 1;
				let page = Math.ceil(totalData/this.workOrderProcessDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.workOrderProcessDetailPageSize = 0;
			// disable paging end
			await WorkOrderProcessDetail.getList(this, filter, this.sortingByWorkOrderProcessDetail, currentPage , this.workOrderProcessDetailPageSize).then(result => {
				this.currentWorkOrderProcessDetailPage = currentPage + 1;
				this.workOrderProcessDetails = result.data;

				this.workOrderProcessDetails.forEach(item => {
					console.log("item", item);
					let partName = item.part.partName
					let partNumber = item.part.partNumber
					if(item.part.partReference) {
						partName = item.part.partName + " / " + item.part.partReference.partName;
						partNumber = item.part.partNumber + " / " + item.part.partReference.partNumber;
					}

					if(item.id == "41") {
						item.isPrintLabel = true;
					}

					item.partPartNumber = partNumber;
					item.partPartName = partName;
				});

				this.totalWorkOrderProcessDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getWorkOrderProcesss : async function(input) {
			let filter = new WorkOrderProcessFilter();
			if (input != undefined) {
				filter.workOrderProcessNumber = input;
			}
			this.isWorkOrderProcessComboLoading = true;
			WorkOrderProcess.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcesss = result.data
				}
				this.isWorkOrderProcessComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getBillOfProcesss : async function(input) {
			let filter = new BillOfProcessFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isBillOfProcessComboLoading = true;
			BillOfProcess.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.billOfProcesss = result.data
				}
				this.isBillOfProcessComboLoading = false;
			})
			.catch(error => {});
		},
		getMachines : async function(input) {
			let filter = new MachineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			this.isMachineComboLoading = true;
			Machine.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.machines = result.data
				}
				this.isMachineComboLoading = false;
			})
			.catch(error => {});
		},
		getLines : async function(input) {
			let filter = new LineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Line.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.lines = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedLineCode(item) {
			if(item == undefined || item == null) {
				this.model.lineCodeId = null;
				this.model.lineCode = null;
			} else {
				this.model.lineCodeId = item.id;
				this.model.lineCode = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getProcessTypes : async function(input) {
			let filter = new ProcessTypeFilter();
			if (input != undefined) {
				filter.code = input;
			}
			ProcessType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.processTypes = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedProcessType(item) {
			if(item == undefined || item == null) {
				this.model.processTypeId = null;
				this.model.processType = null;
			} else {
				this.model.processTypeId = item.id;
				this.model.processType = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		onProcessTypeChange : async function() {
			this.model.lineCodeId = null;
			this.model.lineCode = null;

let item = this.model.processTypeId;
let processTypeObj = this.processTypes.filter(function(processType){ return processType.id == item; });
this.model.processType = processTypeObj.length > 0 ? processTypeObj[0] : null;
			this.getLineCode();
		},
		setSelectedDocumentStatus(item) {
			if(item == undefined || item == null) {
				this.model.documentStatusId = null;
				this.model.documentStatus = null;
			} else {
				this.model.documentStatusId = item.id;
				this.model.documentStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;

			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					WorkOrderProcess.updateData(this, model, id);
				}
			});
		},

		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		editDraftAction(modelEvent) {
			let id = this.modelId;
			if(id != '' && id != null && id != undefined) {
				this.$router.push({ name: 'workorderprocesscreateinboxrequest', params : { id: id } });
			}
		},
		submitAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				WorkOrderProcess.submitApprovalData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$emit("successAction");
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		approveAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to approve this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
							this.isBusy = true;
							WorkOrderProcess.approveApprovalData(this, model, id).then(result => {
								this.isDataCommited = true;
								this.$emit("successAction");
								this.isBusy = false;
							}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		rejectAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to reject this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
							this.isBusy = true;
							WorkOrderProcess.rejectApprovalData(this, model, id).then(result => {
								this.isDataCommited = true;
								this.$emit("successAction");
								this.isBusy = false;
							}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		reviseAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to ask for revision for this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
							this.isBusy = true;
							WorkOrderProcess.reviseApprovalData(this, model, id).then(result => {
								this.isDataCommited = true;
								this.$emit("successAction");
								this.isBusy = false;
							}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		editRequestAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				WorkOrderProcess.editRequest(this, id).then(result => {
					if (result != null) {
						if (result.id != null && result.id != "") {
							this.$router.push({ name: 'workorderprocesscreateinboxrequest', params : { id: result.id } });
						}
					}
					this.isCreateBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		discardAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to discard this data?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
						this.isBusy = true;
						WorkOrderProcess.discardData(this, id).then(result => {
							this.isDataCommited = true;
							this.$emit("successAction");
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		resubmitAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				WorkOrderProcess.resubmitApprovalData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$emit("successAction");
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		cancelAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to cancel this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
						this.isBusy = true;
						WorkOrderProcess.cancelApprovalData(this, model, id).then(result => {
							this.isDataCommited = true;
							this.$emit("successAction");
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		onHidden() {
			// this.getWorkOrderProcesss();
		},
		addRowDataWorkOrderProcessDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.workOrderProcessId =  this.modelId;
					WorkOrderProcessDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getWorkOrderProcessDetails(true);
						this.isShowPopupWorkOrderProcessDetail = false;
					})
				} else {
					model.workOrderProcessId =  this.modelId;
					WorkOrderProcessDetail.createData(this, model)
					.then(result => {
						this.getWorkOrderProcessDetails(true);
						this.isShowPopupWorkOrderProcessDetail = false;
					})
				}
			}
		},
		async editRowDataWorkOrderProcessDetail(id) {
			this.workOrderProcessDetailId = id;
			this.isShowPopupWorkOrderProcessDetail = true; 
		},
		async deleteRowDataWorkOrderProcessDetail(id) {
			WorkOrderProcessDetail.deleteData(this, id).then(result => { this.getWorkOrderProcessDetails(); });
		},
		async resetDataWorkOrderProcessDetail() {
			this.workOrderProcessDetailId = "";
			this.isShowPopupWorkOrderProcessDetail = true;
		},
		async addDataWorkOrderProcessDetail() {
			WorkOrderProcessDetail.createData(this, { workOrderProcessId: this.modelId })
			.then(result => {
				this.getWorkOrderProcessDetails(true);
			})
		},
		async addFromClipboardWorkOrderProcessDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, workOrderProcessId: this.modelId });
				});
				WorkOrderProcessDetail.addFromClipboard(this, parts).then(result => { this.getWorkOrderProcessDetails() });
			});
		},
		async replaceFromClipboardWorkOrderProcessDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, workOrderProcessId: this.modelId });
				});
				WorkOrderProcessDetail.replaceFromClipboard(this, parts).then(result => { this.getWorkOrderProcessDetails() });
			});   
		},
		showPopupUploadWorkOrderProcessDetail() {
			this.isShowPopupUploadWorkOrderProcessDetail = true;
		},
		uploadDataWorkOrderProcessDetail(modalEvent, newDatas) {
			this.isShowPopupUploadWorkOrderProcessDetail = false; 
		},
		downloadWorkOrderProcessDetail(modalEvent) {
			this.isDownloadWorkOrderProcessDetail = true;
			this.filterWorkOrderProcessDetail.workOrderProcessId = this.modelId;
			WorkOrderProcessDetail.downloadDataDetail(this, this.filterWorkOrderProcessDetail).then(result => {
				this.isDownloadWorkOrderProcessDetail = false;
			}).catch(error => { this.isDownloadWorkOrderProcessDetail = false; })
		},
		saveInputWorkOrderProcessDetail(item) {
			WorkOrderProcessDetail.updateDataDetail(this, item, item.id);
		},

		resetModal(modalType) {
			this.isShowPopUpPdf = false;
			this.isShowPopUpPdfList = false;
			this.isShowPopupUploadWorkOrderProcessDetail = false; 
			this.isShowPopupWorkOrderProcessDetail = false; 
			if (modalType == 'WorkOrderProcessDetail') {
				this.getWorkOrderProcessDetails();
			}

			//this.showPopupCopyData = false; 
			//this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				this.isShowWorkOrderProcessDetailFilter = true;

			}
		},
	},
	async mounted() {
		if (this.selectedModel != null && this.selectedModel != "") {
			this.modelId = this.selectedModel.id;
			this.model = this.selectedModel;
			this.getDataDetails();
		} else if (this.selectedModelId != null && this.selectedModelId != "") {
			this.modelId = this.selectedModelId;
			this.getWorkOrderProcess(this.selectedModelId);
		}
	},
	beforeMount() {
		this.filterWorkOrderProcessDetail = new WorkOrderProcessDetailFilter();
		this.fieldsWorkOrderProcessDetail = [
				{"no" : { "class" : "th-number d-stack-none"}}, 
				//{"printAction" : {"class" : "th-printAction d-stackNone", "label" : "Action"}},
				{"part": { "class" : "th-part first-child", "label" : "Part Number", key: 'part', sortable: true }}, 
				{"partName": { "class" : "th-part-name", "label" : "Part Name", key: 'partName', sortable: true }}, 
				{"partClassification": { "class" : "th-part-classification last-child", "label" : "Part Classification", key: 'partClassification', sortable: true }}, 
				{"standarPackagingQty": { "class" : "th-standar-packaging-qty d-stack-none", "label" : "Standard Packaging Qty", key: 'standarPackagingQty', sortable: true }}, 
				{"nextProcess": { "class" : "th-next-process d-stack-none", "label" : "NextProcess", key: 'nextProcess', sortable: true }}, 
				{"machine": { "class" : "th-machine d-stack-none", "label" : "Line Machine", key: 'machine', sortable: true }}, 
				{"sph": { "class" : "th-sph d-stack-none", "label" : "Stroke Per Hour", key: 'sph', sortable: true }}, 
				{"qtyPlan": { "class" : "th-qty-plan d-stack-none", "label" : "Qty (Plan)", key: 'qtyPlan', sortable: true }}, 
				{"hourPlan": { "class" : "th-hour-plan d-stack-none", "label" : "Hour (Plan)", key: 'hourPlan', sortable: true }}, 
				{"customer": { "class" : "th-customer d-stack-none", "label" : "Customer", key: 'customer', sortable: true }}, 
				{"remark": { "class" : "th-remark d-stack-none", "label" : "Remark", key: 'remark', sortable: true }}, 
				{"lotNo": { "class" : "th-lot-no d-stack-none", "label" : "LotNo", key: 'lotNo', sortable: true }}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
		];

		if(this.inboxType == 'FINISHEDSUBMISSION') {
			// Find the index of the "no" item
			const index = this.fieldsWorkOrderProcessDetail.findIndex(item => Object.keys(item)[0] === 'no');
			if (index !== -1) {
				// Insert the "printAction" item after the "no" item
				this.fieldsWorkOrderProcessDetail.splice(index + 1, 0, {"printAction" : {"class" : "th-printAction d-stackNone", "label" : "Action"}});
			}
			this.fieldsWorkOrderProcessDetail.push(
				{"documentStatus": { "class" : "th-document-status d-stack-none", "label" : "Document Status", key: 'documentStatus', sortable: false}}, 
			);
		}
	},
	computed: {
		disableRejectRevise() {
			if (this.model.approvalRemarks == undefined || this.model.approvalRemarks == null || this.model.approvalRemarks == '') return true;
			return false;
		},
	},
	watch : {
		selectedModelId(newValue, oldValue) {
			if (newValue != oldValue) {
				this.modelId = newValue;
				this.getWorkOrderProcess(newValue);
			}
		},
		selectedModel(newValue, oldValue) {
			if (newValue != oldValue) {
				this.modelId = newValue.id;
				this.model = newValue;
				this.getWorkOrderProcessDetails();
			}
		},
		sortByWorkOrderProcessDetail : {
			handler: function() {
				this.getWorkOrderProcessDetails();
			}
		},
		sortDescWorkOrderProcessDetail: {
			handler: function() {
				this.getWorkOrderProcessDetails();
			}
		},
		currentWorkOrderProcessDetailPage: {
			handler: function() {
				this.getWorkOrderProcessDetails();
			}
		},
		workOrderProcessDetailPageSize : {
			handler: function() {
				this.getWorkOrderProcessDetails();
			}
		},
		filterWorkOrderProcessDetail: {
			handler: function() {
				this.getWorkOrderProcessDetails();
			},
			deep: true,
		},


	},
}
</script>
